module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-20-7f4c993ef30f68d2bdff5bb8e3a75143.png";